import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-bs4';

const ViewHistory = () => {
  const [viewlist, setViewlist] = useState([]);
  const [notify, setNotify] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [delId, setDelId] = useState(0);

  useEffect(() => {
    // Simulating data fetch
    const fetchData = async () => {
      // Replace this with your actual fetch call
      const fetchedNotify = { type: 'Info', message: 'This is a notification message.' };
      const fetchedList = [
        { id: 1, fullname: 'John Doe', mobileno: '1234567890' },
        { id: 2, fullname: 'Jane Smith', mobileno: '0987654321' },
      ];
      setNotify(fetchedNotify);
      setViewlist(fetchedList);
      setLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const $ = require('jquery');
    require('datatables.net-bs4');

    if (!loading) {
      $('#customersTable').DataTable();
    }
  }, [loading]);

  const handleDelete = (id) => {
    // Implement your delete logic here
    console.log(`Delete record with ID: ${id}`);
  };

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow p-10">
          <div className="panel-heading pb-4" style={{ border: '1px solid #ececec' }}>
            Type: <b>{notify.type}</b><br />
            Message: <b>{notify.message}</b>
          </div>
          {!loading && viewlist.length > 0 ? (
            <table id="customersTable" className="table table-condensed table-bordered bg-white" style={{ border: '1px solid #ececec' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>#</th>
                  <th>Customer Name</th>
                  <th>Mobile No.</th>
                </tr>
              </thead>
              <tbody>
                {viewlist.map((post, index) => (
                  <tr key={post.id}>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{index + 1}</td>
                    <td>{post.fullname}</td>
                    <td>{post.mobileno}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>No records found.</div>
          )}
        </div>

        <input type="hidden" name="delid" id="delid" value={delId} />

        <div id='myModal' className='modal'>
          <div className="modal-dialog panel panel-default panel-border top">
            <div className="modal-content">
              <div id='myModalContent'></div>
            </div>
          </div>
        </div>

        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default ViewHistory;
